import React, {useState} from "react"
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle,} from "reactstrap"
import {useOfficeTranslation} from "../../../i18n/OfficeTranslation"
import {officeLocaleOptions} from "../../../i18n/officeTranslations"

const LanguageDropdown = () => {
  const [menu, setMenu] = useState(false)
  const {locale, setLocale, t} = useOfficeTranslation()
  const selectedLocale = officeLocaleOptions.find(option => option.value === locale)

  const changeLanguageAction = lang => {
    setLocale(lang)
  }

  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block header-language-dropdown">
        <DropdownToggle className="btn header-item header-action-button" tag="button">
          <span className="badge bg-primary bg-soft text-primary">
            {selectedLocale?.shortLabel}
          </span>
          <span className="visually-hidden">{t("common.languageDropdown.language")}: {selectedLocale?.nativeLabel}</span>
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {officeLocaleOptions.map(option => (
            <DropdownItem
              key={option.value}
              onClick={() => changeLanguageAction(option.value)}
              className={`notify-item language ${
                locale === option.value ? "active" : "none"
              }`}
            >
              <span className="badge bg-light text-dark me-2">
                {option.shortLabel}
              </span>
              <span className="align-middle">
                {option.nativeLabel}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default (LanguageDropdown)
